import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DASHBOARD_TYPE } from '@utils/constants';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { loadingSelector } from '@store/aiAlerts/diagnostics/selectors';
import { Retry } from '@components/common';
import { setSelectedAiAlert } from '@store/trends/aiAlerts/actions';

export const PreAppAiAlertDiagnostics = (props) => {
  const dispatch = useDispatch();
  const { match } = props;
  const selectedAlertId = match.params.aiAlertId;
  const rootCause = match.params.rootCauseParam;
  const loading = useSelector(loadingSelector);
  const selectedAlertType = 'APP_ALERT';
  dispatch(setSelectedAiAlert({ selectedAlertId, selectedAlertType }));
  const dashboard = {
    'module:trends': {
      aiAlerts: {
        selectedAlertId,
        selectedAlertType,
      },
    },
  };

  dispatch(createTempDashboard(DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS, dashboard, `${rootCause}`));

  if (loading) {
    return <Retry isLoading={loading} />;
  }

  return null;
};
